import { DEFAULT_BRANDING, } from './types';
export const DEFAULT_BACKGROUND_IMAGE_URL = 'https://m.provisionapp.io/static/media/background-init.85ffeb88.jpeg';
const VALID_COLOR_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$|^rgb\(|^rgba\(|^hsl\(|^hsla\(|^color\(/;
/**
 * Whether a value is safe to hand to CSS as a colour: hex, rgb(), rgba(), hsl(), hsla() or
 * color(). Partner-supplied colours are free text, so every one is gated on this.
 */
export function isValidColor(value) {
    return typeof value === 'string' && VALID_COLOR_REGEX.test(value.trim());
}
function orDefaultColor(value, defaultColor) {
    const v = typeof value === 'string' ? value.trim() : '';
    return isValidColor(v) ? v : defaultColor;
}
export function resolveBranding(branding) {
    if (!branding)
        return DEFAULT_BRANDING;
    const primary = orDefaultColor(branding.primaryColor, DEFAULT_BRANDING.primaryColor);
    return {
        primaryColor: primary,
        secondaryColor: orDefaultColor(branding.secondaryColor, primary),
        textSecondary: orDefaultColor(branding.textSecondary, DEFAULT_BRANDING.textSecondary),
        grey300: orDefaultColor(branding.grey300, DEFAULT_BRANDING.grey300),
    };
}
export function formatPrice(priceCents) {
    return (priceCents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
